export const vtexConstants = {
    VTEX_ACCOUNTS_SUCCESS: 'VTEX_ACCOUNTS_SUCCESS',
    VTEX_ACCOUNTS_ERROR: 'VTEX_ACCOUNTS_ERROR',
    VTEX_ACCOUNTS_REQUEST: 'VTEX_ACCOUNTS_REQUEST',
    VTEX_ACCOUNTS_RESET: 'VTEX_ACCOUNTS_RESET',
};
